import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import VideoShortlistCardMenu from './VideoShortlistCardMenu';
import { ShortlistMosaic, MosaicTile } from '../Shortlists/ShortlistMosaic';
import { getVideoThumbnail } from '../../../utils/downloadHelpers';

interface Props {
  shortlist: any;
  fetchShortlists: () => void;
}

const VideoShortlistCard = ({ shortlist, fetchShortlists }: Props) => {
  const navigate = useNavigate();

  const videos = useMemo(() => shortlist?.videos || [], [shortlist]);
  const tiles = useMemo<MosaicTile[]>(
    () => videos.slice(0, 8).map((v: any) => ({ key: v.id, src: getVideoThumbnail(v) })),
    [videos]
  );

  if (!shortlist) return null;

  const open = () => navigate(`/videos/shortlists/${shortlist.id}`);
  const edited = shortlist.updated_at || shortlist.updatedAt;

  return (
    <>
      <div
        className="bg-surface border border-border-token rounded-xl overflow-hidden flex flex-col h-full w-full box-border cursor-pointer transition-colors duration-150 hover:border-accent"
        style={{ boxShadow: 'var(--sh-1)' }}
        onClick={open}
        title={shortlist.name}
      >
        <ShortlistMosaic
          tiles={tiles}
          total={videos.length}
          countLabel={`${videos.length} ${videos.length === 1 ? 'video' : 'videos'}`}
          emptyTitle="No videos yet"
          emptyAction={{ label: 'Add from Videos', onClick: () => navigate('/videos') }}
        />

        <div className="flex flex-col flex-1 min-h-0" style={{ gap: 12, padding: '13px 15px 15px' }}>
          <div className="flex items-start gap-2.5">
            <div className="flex-1 min-w-0">
            <div
              className="font-bold text-text-1"
              style={{
                fontSize: 15.5,
                lineHeight: 1.3,
                display: '-webkit-box',
                WebkitLineClamp: 2,
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
              }}
            >
              {shortlist.name}
            </div>
            </div>
            <span className="flex items-center shrink-0" onClick={(e) => e.stopPropagation()}>
              <VideoShortlistCardMenu shortlist={shortlist} fetchShortlists={fetchShortlists} />
            </span>
          </div>

          <div
            className="flex items-center justify-end gap-3 border-t border-border-token mt-auto"
            style={{ paddingTop: 11 }}
          >
            {edited && (
              <span className="text-text-2 shrink-0" style={{ fontSize: 12.5 }}>
                {moment(edited).fromNow()}
              </span>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default VideoShortlistCard;
